/** Einzahl, wenn ein Platzhalter genau 1 ist. Dieselbe Liste wie api/core/count_agreement.py. */

import { parseWholeNumber } from "@/lib/templateConditions";

const SINGULAR_FORMS: Record<string, string> = {
  Nächte: "Nacht",
  Nächten: "Nacht",
  Tage: "Tag",
  Tagen: "Tag",
  Wochen: "Woche",
  Monate: "Monat",
  Monaten: "Monat",
  Jahre: "Jahr",
  Jahren: "Jahr",
  Stunden: "Stunde",
  Minuten: "Minute",
  Personen: "Person",
  Gäste: "Gast",
  Gästen: "Gast",
  Kinder: "Kind",
  Kindern: "Kind",
  Kleinkinder: "Kleinkind",
  Kleinkindern: "Kleinkind",
  Babys: "Baby",
  Erwachsene: "Erwachsener",
  Erwachsenen: "Erwachsenem",
  Hunde: "Hund",
  Hunden: "Hund",
  Katzen: "Katze",
  Fahrzeuge: "Fahrzeug",
  Fahrzeugen: "Fahrzeug",
  Wohnmobile: "Wohnmobil",
  Wohnmobilen: "Wohnmobil",
  Stellplätze: "Stellplatz",
  Stellplätzen: "Stellplatz",
  Plätze: "Platz",
  Plätzen: "Platz",
  Übernachtungen: "Übernachtung",
  Begleitpersonen: "Begleitperson",
  Mitreisende: "Mitreisender",
  Mitreisenden: "Mitreisendem",
  Jugendliche: "Jugendlicher",
  Jugendlichen: "Jugendlichem",
  Betten: "Bett",
  Zelte: "Zelt",
  Zelten: "Zelt",
  Fahrräder: "Fahrrad",
  Fahrrädern: "Fahrrad",
  Elektrofahrräder: "Elektrofahrrad",
  "E-Bikes": "E-Bike",
  Autos: "Auto",
  Motorräder: "Motorrad",
  Motorrädern: "Motorrad",
  Aufenthalte: "Aufenthalt",
  Aufenthalten: "Aufenthalt",
  Buchungen: "Buchung",
  Rechnungen: "Rechnung",
  Mahnungen: "Mahnung",
  Tiere: "Tier",
  Tieren: "Tier",
  Besuche: "Besuch",
  Besuchen: "Besuch",
};

const FOLDED: Record<string, string> = {};
for (const [word, singular] of Object.entries(SINGULAR_FORMS)) {
  FOLDED[word.toLowerCase()] = singular;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

const WORDS = Object.keys(SINGULAR_FORMS)
  .sort((left, right) => right.length - left.length)
  .map(escapeRegExp)
  .join("|");

const PAIR_RE = new RegExp(
  `\\{\\{\\s*([a-zA-Z0-9_]+)\\s*\\}\\}((?:(?!\\{\\{)(?:\\s|&nbsp;|&#160;|<br\\s*/?\\s*>|</?(?:strong|b|em|i|u|span)\\b[^>]*>))*)(${WORDS})(?![\\p{L}\\p{N}_])`,
  "giu",
);
const FORM_RE = /\{\{\s*([a-zA-Z0-9_]+)\s*\|\s*([^|{}]+?)\s*\|\s*([^|{}]+?)\s*\}\}/g;

export function isSingularCount(value: string | null | undefined): boolean {
  const number = parseWholeNumber(value);
  return number != null && Math.abs(number - 1) < 1e-9;
}

export function applyCountAgreement(text: string, values: Record<string, string>): string {
  const withForms = text.replace(FORM_RE, (match, key: string, one: string, many: string) => {
    if (!(key in values)) return match;
    return isSingularCount(values[key]) ? one.trim() : many.trim();
  });
  PAIR_RE.lastIndex = 0;
  return withForms.replace(PAIR_RE, (match, key: string, gap: string, word: string) => {
    if (!(key in values)) return match;
    const value = values[key] ?? "";
    const chosen = isSingularCount(value) ? (FOLDED[word.toLowerCase()] ?? word) : word;
    return `${value}${gap}${chosen}`;
  });
}
